import styled from "styled-components";

export const StyledMenu = styled.aside`
    max-width: ${(props) => (props.isMobile ? "100%" : "180px")};
    width: 100%;
    background-color: #2c3b82;
    font-size: 0.9rem;
    text-align: left;
    padding-top: 5px;
    min-height: calc(100vh - 66px);

    & div {
        color: #fff;
        cursor: pointer;
    }

    & div:hover {
        color: #ee4b21;
    }

    & a {
        text-decoration: none !important;
    }

    & .text-orange {
        color: #ef4623;
    }

    & .icon-item {
        width: 40px;
        text-align: center;
    }
    & div.interLink{
        cursor: pointer;
        min-height: 30px;
    }

    .logo-row-menu{
        max-width: 160px;
        position:fixed;
        bottom: 0;
        left: 0;
        text-align: center;
    }



   .logo-img-menu{
        margin-bottom: 10px;
        margin-left: auto;
        width: 70%;
        //padding: 0 0rem ;
    }

    @media (max-width: 1400px) {

    .logo-row-menu{
        max-width: 160px;
        position:fixed;
        bottom: 0;
        left: 0;
        text-align: center;
    }

    .logo-img-menu{
         margin-bottom: 10px;
         margin-left: auto;
         padding: 0 10px;
     }

     font-size: 0.85rem;
    }

    .icon-sub svg {
        height: 10px;
        width: 10px;
        margin-right: -13px;
        margin-bottom: 3px;
    }

`;
